<app-category-header [text]="'Flash'"></app-category-header>

<div class="sdds-row">
    <div
        class="sdds-col-max-3 sdds-col-xxlg-3 sdds-col-xlg-3 sdds-col-lg-4 sdds-col-md-12 sdds-col-sm-12 sdds-col-xs-12 mb-16">
        <!-- [ngClass]="{'loading': !category}"> -->
        <app-category-items *ngIf="category" [specification]="specification"
            [specificationVersion]="specificationVersion" [category]="category"
            [isAllowed]="canEditCategoryItems()"></app-category-items>
    </div>

    <div
        class="sdds-col-max-9 sdds-col-xxlg-9 sdds-col-xlg-9 sdds-col-lg-8 sdds-col-md-12 sdds-col-sm-12 sdds-col-xs-12 mb-16">
        <div *ngIf="flashItem"> <!--[ngClass]="{'loading': isLoading}"> -->
            <app-editable-textbox [text]="flashItem.name" (textEditedEventEmitter)="editingNameDone($event)"
                [editingNotAllowed]="!isEditingAllowed" [editingNotAllowedReason]="editingNotAllowedReason"
                enclosingElement="h2" [isAllowed]="canEditCategoryItems()"></app-editable-textbox>

            <div class="sdds-banner">
                <div class="sdds-banner-body">
                    This feature allows you to configure a diagnostic routine to temporarily unlock JTAG.
                </div>
            </div>
            <br />
            <h4 class="sdds-headline-04 mt-16">Prerequisites</h4>
            <div class="sdds-banner">
                <div class="sdds-banner-body">
                    Select the <b>Security Access Mode</b> that must be unlocked before this Flash is executed.
                </div>
            </div>

            <div class="flex items-end mt-16 mb-16">
                <div class="sdds-dropdown sdds-dropdown-small sdds-on-white-bg" style="width: 300px;">
                    <span class="sdds-dropdown-label-outside">Security Access Mode</span>
                    <select name="flashSecurityAccessMode" [ngModel]="flashItem.model.securityAccessModeName ?? null"
                        (ngModelChange)="onSecurityAccessModeChanged($event)" [disabled]="!canEditSecurityAccessMode">
                        <option [ngValue]="null">-- None --</option>
                        <option *ngFor="let mode of availableSecurityAccessModes" [ngValue]="mode">{{mode}}</option>
                        <option
                            *ngIf="flashItem.model.securityAccessModeName && !availableSecurityAccessModes.includes(flashItem.model.securityAccessModeName)"
                            [ngValue]="flashItem.model.securityAccessModeName">
                            {{flashItem.model.securityAccessModeName}} (missing)
                        </option>
                    </select>
                </div>
                <button type="button" class="icon-btn ml-10"
                    *ngIf="flashItem.model.securityAccessModeName"
                    [disabled]="!availableSecurityAccessModes.includes(flashItem.model.securityAccessModeName)"
                    (click)="navigateToSecurityAccessMode()"
                    matTooltip="Navigate to the connected security access mode"
                    aria-label="Navigate to the connected security access mode">
                    <mat-icon class="text-gray-600">arrow_forward</mat-icon>
                </button>
                <button type="button" class="icon-btn ml-5"
                    *ngIf="flashItem.model.securityAccessModeName && canEditSecurityAccessMode"
                    (click)="confirmDisconnectSecurityAccessMode()"
                    matTooltip="Disconnect the security access mode from this Flash"
                    aria-label="Disconnect the security access mode from this Flash">
                    <mat-icon class="text-red-500">close</mat-icon>
                </button>
            </div>
            <br />
            <app-assigned-services-viewer [serviceExecutionSequence]="flashItem.serviceExecutionSequence"
                [propertyType]="flashItem.propertyType" [isReadOnly]="!isEditingAllowed"
                [hideAddButtonWithOneService]="true">
            </app-assigned-services-viewer>
        </div>
    </div>
</div>

<a id="areYouSureModal" appOpenModal [open]="openDisconnectConfirmEventEmitter" style="display: none"></a>
<app-confirm-dialogue [message]="disconnectSecurityAccessModeMessage"
    (yesEventEmitter)="disconnectSecurityAccessMode()"></app-confirm-dialogue>